import type { Tag } from '../../../types'
import type { Perk } from '../hooks/types'

export enum RssType {
  all = 'all',
  selected = 'selected',
}

export enum FormFields {
  mode = 'mode',
  type = 'type',
  title = 'title',
  description = 'description',
  image = 'image',
  rssType = 'rssType',
  rssTags = 'rssTags',
  hidden = 'hidden',
  selectedTiers = 'selectedTiers',
  selectedRoles = 'selectedRoles',
  removeImage = 'removeImage',
}

export type FormValues = {
  [FormFields.mode]: 'edit' | 'create'
  [FormFields.type]: Perk['type']
  [FormFields.title]: string
  [FormFields.description]?: string
  [FormFields.image]?: string
  [FormFields.rssType]: RssType
  [FormFields.rssTags]: Tag[]
  [FormFields.hidden]: boolean
  [FormFields.selectedTiers]?: Record<string, boolean>
  [FormFields.selectedRoles]: Record<string, string[]>
  [FormFields.removeImage]: boolean
}

export type Props = {
  perk?: Perk
  selectedType?: Perk['type']
  selectedTiers?: Record<string, boolean>
  onExistingPerkAdd?: (perk: Perk, selectedTiers?: Record<string, boolean>) => void
  close: () => void
}
